__turbopack_context__.v({
  "BeSure": "BeSureBlock-module-scss-module__xYY0UW__BeSure",
  "BeSure__btn": "BeSureBlock-module-scss-module__xYY0UW__BeSure__btn",
  "BeSure__item": "BeSureBlock-module-scss-module__xYY0UW__BeSure__item",
  "BeSure__itemSubtitle": "BeSureBlock-module-scss-module__xYY0UW__BeSure__itemSubtitle",
  "BeSure__itemTextWrapper": "BeSureBlock-module-scss-module__xYY0UW__BeSure__itemTextWrapper",
  "BeSure__itemTitle": "BeSureBlock-module-scss-module__xYY0UW__BeSure__itemTitle",
  "BeSure__list": "BeSureBlock-module-scss-module__xYY0UW__BeSure__list",
  "BeSure__mainContentContainer": "BeSureBlock-module-scss-module__xYY0UW__BeSure__mainContentContainer",
  "BeSure__notationContainer": "BeSureBlock-module-scss-module__xYY0UW__BeSure__notationContainer",
  "BeSure__notationText": "BeSureBlock-module-scss-module__xYY0UW__BeSure__notationText",
  "BeSure__subtitle": "BeSureBlock-module-scss-module__xYY0UW__BeSure__subtitle",
  "BeSure__textWrapper": "BeSureBlock-module-scss-module__xYY0UW__BeSure__textWrapper",
  "BeSure__title": "BeSureBlock-module-scss-module__xYY0UW__BeSure__title",
});
